import { useFeatureFlag } from '../useFeatureFlag'
import { SHOW_EPT_FEATURE_FLAG } from '../../../../ReactRouting/Constants/FeatureFlags'
import { useCheckUserHasPermissions } from '../../../../ReactRouting/Hooks/useCheckPermissions'
import { USER_MANAGEMENT_PERMISSIONS } from '../../Utils/PermissionsUtil'
import { useCheckUserHasTelsysOfLicence } from '../../../../ReactRouting/Hooks/useCheckUserTelsysAreEnterprise'
import { ReportingAccessLevels } from '../../../../NonReact/constants/Permissions'

export const useUserHasUserManagementPermission = (): Definable<boolean> => {
    const isEPTFeatureEnabled: Definable<boolean> = useFeatureFlag(SHOW_EPT_FEATURE_FLAG)
    const hasUserManagementPermissions: Definable<boolean> = useCheckUserHasPermissions(USER_MANAGEMENT_PERMISSIONS)
    const areUserTelsysEnterprise: Definable<boolean> = useCheckUserHasTelsysOfLicence(ReportingAccessLevels.ENTERPRISE)

    return isEPTFeatureEnabled && hasUserManagementPermissions && areUserTelsysEnterprise
}
